// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__VmfDn","options":"AnswerScale_options__3hRN0","selected":"AnswerScale_selected__bOUUi"};